import axios from "axios";
import { useConsoleAuthStore } from "store/useConsoleAuthStore";
import { usePopupStore } from "store/usePopupStore";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 100000,
});

let activeRequests = 0;

axiosInstance.interceptors.request.use(
    config => {
        activeRequests++;
        // 로딩팝업 표시
        const { setLoadingPop } = usePopupStore.getState();
        setLoadingPop(true);

        const token = useConsoleAuthStore.getState().accessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        activeRequests = Math.max(activeRequests - 1, 0);
        const { setLoadingPop } = usePopupStore.getState();
        if (activeRequests === 0) setLoadingPop(false);
        return Promise.reject(error);
    },
);

axiosInstance.interceptors.response.use(
    response => {
        activeRequests = Math.max(activeRequests - 1, 0);
        const { setLoadingPop } = usePopupStore.getState();
        if (activeRequests === 0) setLoadingPop(false);
        return response;
    },
    error => {
        activeRequests = Math.max(activeRequests - 1, 0);
        const { setLoadingPop, setConfirmPop } = usePopupStore.getState();
        if (activeRequests === 0) setLoadingPop(false);

        // 공통적으로 알림 팝업 표시
        const { status, data } = error.response || {};
        const errorMessage = data?.message || "알 수 없는 에러가 발생했습니다.";

        if (status === 500) {
            setConfirmPop(true, "알림", "서버 오류가 발생했습니다.", 1);
        } else if (status === 401) {
            const logout = useConsoleAuthStore.getState().logout;
            logout();
            localStorage.clear();
        } else {
            setConfirmPop(true, "알림", errorMessage, 1);
        }

        return Promise.reject(error);
    },
);

export default axiosInstance;
